import React, { useEffect, useState } from "react";
import { Form, Input, Upload, Button, Radio, Select, Row, Col, Modal, Typography, message, Collapse, Card, DatePicker, Spin, Tooltip, Divider } from "antd";
import { UploadOutlined, ExclamationCircleOutlined, DeleteOutlined, PlusCircleOutlined, FileOutlined, LeftOutlined, RightOutlined,ArrowRightOutlined } from "@ant-design/icons";
import { useHistory, useLocation } from "react-router-dom";
import LeftLayout from "../pageHeader/LeftLayout";
import { routes } from "../../routes/Routes";
import CollapsePanel from "antd/lib/collapse/CollapsePanel";
import "../../assets/dist/NewApplication/NewApplicantCommon.css";
import moment from 'moment';
import _NewapplicationService from "../../modules/NewapplicationService";
import { APP_BLOB_ROOT, COMMON_ERROR_MSG, SUBMISSION_FAILED } from "../../constants/constants";
import { ScreenNamebalancesheettotalasset } from "../../constants/DataConstants";
import { upload } from "@testing-library/user-event/dist/upload";
import CurrencyInput from "../../components/CurrencyInput";
import ShowApplicationId from "../NewApplication/ShowApplicationId";
import ApplicationProgressBar from "./ApplicationProgressBar";
import ButtonComponent from "../../components/Button/Button";

const { confirm } = Modal;
const { Title } = Typography;
const { Option } = Select;

const BalanceSheetTotalAssets = () => {
    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const history = useHistory();
    const [file, setFile] = useState({});
    const applicationId = localStorage.getItem("Id");
    const ApplicationId = localStorage.getItem("ApplicationId");
    const location = useLocation();
    let data = location.state;
    let applnObjId = "";
    let activeKeyTab = null;
    let fromDashboard = false;

    if (data && data.applicationObjId) {
        applnObjId = data.applicationObjId;
    }

    if (data && data.isFromDashboard) {
        fromDashboard = data.isFromDashboard;
    }
    if (data && data.activeKey) {
        activeKeyTab = data.activeKey;
    }
    const [appObjId] = useState(applnObjId);
    const [isFromDashboard] = useState(fromDashboard);
    const [tabActiveKey] = useState(activeKeyTab);

    useEffect(() => {
        fetchAssets();
        fetchVestedIntrestPensionData();
        fetchUnlistedStocksData();
        fetchReInvestmentData();
        fetchGeneralInterestData();
        getBalancesheetTotalassetDataByID();
    }, []);

    const [reownedCount, setReownedCount] = useState(1)
    const [generalPartnershipCount, setgeneralPartnershipCount] = useState(1)

    const [assets, setAssets] = useState([
        {
            Id: null,
            RowID: reownedCount,
            PropertyLocation: "",
            Owner: "",
            isBeneficialInterestAssigned: null,
            beneficialInterestDetails: "",
            isObligatedOnDebt: null,
            details: "",
            dateAcquired: null,
            cost: "",
            marketValue: "",
            mortgagor: "",
            maturity: null,
            amount: "",
            uploadPath: "",
            fullUrl: ""
        },
    ]);

    const [VestedInterest, setVestedInterest] = useState([
        { Id: null, NameofCompany: "", Owner: "", Beneficiary: "", PayoutBasis: "", DateAvailable: "", Amount: "" },
    ]);

    const [UnlistedStocks, setUnlistedStocks] = useState([
        { Id: null, DescriptionOfSecurities: "", InNameOf: "", Ownership: "", BookValue: "", BookValueAmount: "", IfPledgedTowhom: "" },
    ]);


    const [ReInvestmentsAssets, setReInvestmentsAssets] = useState([
        {
            Id: null,
            PropertyLocation: "",
            Owner: "",
            isBeneficialInterestAssigned: null,
            beneficialInterestDetails: "",
            isObligatedOnDebt: null,
            details: "",
            dateAcquired: null,
            cost: "",
            marketValue: "",
            mortgagor: "",
            maturity: null,
            amount: ""
        },
    ]);

    const [generalInterest, setGeneralInterest] = useState([
        { Id: null, RowID: generalPartnershipCount, NameofPartnership: "", TypeofInvestment: "", LimitedorGeneral: "", AmountInvested: "", FairMarketValueofPartnershipInterest: "", uploadPath: "", fullUrl: "" },
    ]);
    const [balancesheettotalassetInfo, setBalancesheettotalassetInfo] = useState({});

    //const [assetErrors, setAssetErrors] = useState([]);
    // const [vestedInterestErrors, setVestedInterestErrors] = useState([]);
    // const [unlistedStockErrors, setUnlistedStockErrors] = useState([]);
    // const [reInvestmentErrors, setReInvestmentErrors] = useState([]);
    // const [generalInterestErrors, setGeneralInterestErrors] = useState([]);

    const addReOwnedPersonalResidences = () => {
        setReownedCount(reownedCount + 1);
        setAssets([
            ...assets,
            {
                Id: null,
                RowID: reownedCount + 1,
                PropertyLocation: "",
                Owner: "",
                isBeneficialInterestAssigned: null,
                beneficialInterestDetails: "",
                isObligatedOnDebt: null,
                obligatedDebtDetails: "",
                dateAcquired: null,
                cost: "",
                marketValue: "",
                mortgagor: "",
                maturity: null,
                amount: "",
                uploadPath: "",
                fullUrl: "",
            },
        ]);

    };


    const addVestedInterest = () => {
        setVestedInterest([
            ...VestedInterest,
            { Id: null, NameofCompany: "", Owner: "", Beneficiary: "", PayoutBasis: "", DateAvailable: "", Amount: "" },
        ]);
    }


    const addUnlistedStocks = () => {
        setUnlistedStocks([
            ...UnlistedStocks,
            { Id: null, DescriptionOfSecurities: "", InNameOf: "", Ownership: "", BookValue: "", BookValueAmount: "", IfPledgedTowhom: "" },
        ])

    }
    const addReInvestmentsAssets = () => {
        setReInvestmentsAssets([
            ...ReInvestmentsAssets,
            {
                Id: null,
                PropertyLocation: "",
                Owner: "",
                isBeneficialInterestAssigned: null,
                beneficialInterestDetails: "",
                isObligatedOnDebt: null,
                details: "",
                dateAcquired: null,
                cost: "",
                marketValue: "",
                mortgagor: "",
                maturity: null,
                amount: ""
            },
        ]);
    }

    const addGeneralInterest = () => {
        setgeneralPartnershipCount(generalPartnershipCount + 1);
        setGeneralInterest([
            ...generalInterest,
            { Id: null, RowID: generalPartnershipCount + 1, NameofPartnership: "", TypeofInvestment: "", LimitedorGeneral: "", AmountInvested: "", FairMarketValueofPartnershipInterest: "", uploadPath: "", fullUrl: "" },
        ]);
    }

    useEffect(() => {

    }, [reownedCount, generalPartnershipCount]);

    const deleteReOwnedPersonalResidences = (index) => {
        const idToDelete = assets[index].Id;
        confirm({
            title: "Are you sure you want to delete?",
            icon: <ExclamationCircleOutlined />,
            onOk: async () => {
                try {
                    if (idToDelete > 0) {
                        try {
                            const res = await _NewapplicationService.deleteOwnPersonalResidenceByOwnID(idToDelete);
                            if (res.data.IsSuccess) {
                                message.success(res?.data?.Message);
                                setAssets(prev => prev.filter((_, idx) => idx !== index));
                            } else {
                                message.error(res?.data?.Message || COMMON_ERROR_MSG);
                            }
                        } catch (error) {

                            message.error("An unexpected error occurred.");
                        }
                    } else {
                        setAssets(prev => prev.filter((_, idx) => idx !== index));
                    }

                } catch (err) {
                    console.error("Delete error:", err);
                    message.error("Failed to delete");
                }
            },
        });
    };

    const deleteVestedInterest = (index) => {
        const idToDelete = VestedInterest[index].Id;
        confirm({
            title: "Are you sure you want to delete",
            icon: <ExclamationCircleOutlined />,
            okText: "Yes",
            cancelText: "No",
            async onOk() {
                try {
                    if (idToDelete) {
                        const res = await _NewapplicationService.deleteVestedIntrestPensionByOwnID(idToDelete);
                        if (res.data.IsSuccess) {
                            message.success(res?.data?.Message);
                        } else {
                            message.error(res?.data?.Message || COMMON_ERROR_MSG);
                        }

                    }
                    const updated = VestedInterest.filter((_, idx) => idx !== index);
                    setVestedInterest(updated);
                } catch (err) {
                    message.error(COMMON_ERROR_MSG);
                }
            },
        });
    };

    const deleteUnlistedStocks = (index) => {
        const idToDelete = UnlistedStocks[index].Id;
        confirm({
            title: "Are you sure you want to delete",
            icon: <ExclamationCircleOutlined />,
            okText: "Yes",
            cancelText: "No",
            async onOk() {
                try {
                    if (idToDelete) {
                        const res = await _NewapplicationService.deleteUnListedStocksByunlistedStockID(idToDelete);
                        if (res.data.IsSuccess) {
                            message.success(res?.data?.Message);
                        } else {
                            message.error(res?.data?.Message || COMMON_ERROR_MSG);
                        }

                    }
                    setUnlistedStocks(UnlistedStocks.filter((_, idx) => idx !== index));
                } catch (err) {
                    message.error(COMMON_ERROR_MSG);
                }
            },

        });
    };

    const deleteReInvestmentsAssets = (index) => {
        const idToDelete = ReInvestmentsAssets[index].Id;
        confirm({
            title: "Are you sure you want to delete this real estate asset?",
            icon: <ExclamationCircleOutlined />,
            okText: "Yes",
            cancelText: "No",
            async onOk() {
                try {
                    if (idToDelete) {
                        const res = await _NewapplicationService.deleteInvestmentByInvestmentID(idToDelete);
                        if (res.data.IsSuccess) {
                            message.success(res?.data?.Message);
                        } else {
                            message.error(res?.data?.Message || COMMON_ERROR_MSG);
                        }

                    }
                    setReInvestmentsAssets(ReInvestmentsAssets.filter((_, idx) => idx !== index));
                } catch (err) {
                    message.error(COMMON_ERROR_MSG);
                }
            },

        });
    };

    const deleteGeneralInterest = (index) => {
        const idToDelete = generalInterest[index].Id;
        confirm({
            title: "Are you sure you want to delete this real estate asset?",
            icon: <ExclamationCircleOutlined />,
            okText: "Yes",
            cancelText: "No",
            async onOk() {
                try {
                    if (idToDelete) {
                        const res = await _NewapplicationService.deleteGeneralAndLimitedPartenershipByInvestmentID(idToDelete);
                        if (res.data.IsSuccess) {
                            message.success(res?.data?.Message);
                        } else {
                            message.error(res?.data?.Message || COMMON_ERROR_MSG);
                        }
                    }
                    setGeneralInterest(generalInterest.filter((_, idx) => idx !== index));
                } catch (err) {
                    message.error(COMMON_ERROR_MSG);
                }
            },
        });
    };

    const onBack = () => {
        if (isFromDashboard) {
            history.push({ pathname: routes.dashboard.path, state: { appObjId, activeKey: tabActiveKey } });
        } else {
            history.push(routes.balanceSheetAssets.path);
        }
    };
    const onFinish = async (values) => {
        const totalAssets = parseFloat(values?.totalLiquidMarketableAssets);
        if (!totalAssets || isNaN(totalAssets) || totalAssets <= 0) {
            message.error("Please enter an amount in at least one field (Total Assets should not be 0)");
            return false;
        }
        // const isReownSaved = await handleSave(false);
        // const isVestedIntrestPensionSaved = await handleSaveVestedIntrestPension(false);
        // const isUnlistedStocksSaved = await handleSaveUnlistedStocks(false);
        // const isReInvestmentSaved = await saveReInvestmentData(false);
        // const isGeneralInterestSaved = await saveGeneralInterest(false);
        // if (!isReownSaved || !isVestedIntrestPensionSaved || !isUnlistedStocksSaved || !isReInvestmentSaved || !isGeneralInterestSaved) {
        //     message.error("Please correct validation errors in the form before submitting.");
        //     return;
        // }
        try {
            const payload = {
                Id: fromDashboard ? appObjId : applicationId,
                ScreenName: ScreenNamebalancesheettotalasset,
                ApplicationId: localStorage.getItem("ApplicationId"),
                OwnPersonalResidenceTotal: values.ownPersonalResidenceTotal,
                VestedIntrestPensionTotal: values.vestedIntrestPensionTotal,
                IRAKeoghAccountsTotal: values.iraKeoghAccountsTotal,
                UnListedStocksTotal: values.unListedStocksAndAccountsTotal,
                EquityInterestInBusinessTotal: values.equityInterestInBusinessCount,
                InvestmentTotal: values.investmentTotal,
                GeneralAndLimitedPartenershipIntrestTotal: values.generalAndLimitedPartenershipIntrestTotal,
                PersonalPropertyTotal: values.personalPropertyTotal,
                OtherAssetsTotal: values.otherAssetsTotal,
                AssetsTotal: values.totalLiquidMarketableAssets,
                IsBalancesheetTotalAssetCompleted: true,
            };

            const res = await _NewapplicationService.updateApplicantFinancialData(payload);
            if (res.data.IsSuccess) {
                message.success(res.data.Message);
                getBalancesheetTotalassetDataByID();
                if (isFromDashboard) {
                    history.push({ pathname: routes.dashboard.path, state: { appObjId, activeKey: tabActiveKey } });
                }
                else {
                    history.push(routes.balanceSheetTotalLiabilities.path);
                }
            } else {
                message.error("Failed to submit data.");
            }
        } catch (error) {
            console.error("API Error:", error);
            message.error("An error occurred while submitting the data.");
        }

    };
    const getBalancesheetTotalassetDataByID = async () => {
        try {
            //  setLoading(true);
            const res = await _NewapplicationService.getFinancialStatementData(fromDashboard ? appObjId : applicationId, ScreenNamebalancesheettotalasset);

            if (res.data) {
                let resObj = res?.data.Obj;
                setBalancesheettotalassetInfo({
                    ownPersonalResidenceTotal: resObj.OwnPersonalResidenceTotal,
                    vestedIntrestPensionTotal: resObj.VestedIntrestPensionTotal,
                    iraKeoghAccountsTotal: resObj.IRAKeoghAccountsTotal,
                    unListedStocksAndAccountsTotal: resObj.UnListedStocksTotal,
                    equityInterestInBusinessCount: resObj.EquityInterestInBusinessTotal,
                    investmentTotal: resObj.InvestmentTotal,
                    generalAndLimitedPartenershipIntrestTotal: resObj.GeneralAndLimitedPartenershipIntrestTotal,
                    personalPropertyTotal: resObj.PersonalPropertyTotal,
                    otherAssetsTotal: resObj.OtherAssetsTotal,
                    totalLiquidMarketableAssets: resObj.AssetsTotal ? resObj.AssetsTotal : resObj.LiquidMarketableAssetsTotal,
                    LiquidMarketableAssetsTotal: resObj.LiquidMarketableAssetsTotal,
                    Application_Status_Id: resObj.Application_Status_Id
                });

                // setLoading(false);
            }
        } catch (e) {
            // setLoading(false);
            console.log(e);
        }
    };
    const handleChange = (idx, field, value) => {
        const updated = [...assets];
        updated[idx][field] = value;
        setAssets(updated);
    };
    const fetchAssets = async () => {
        try {
            const res = await _NewapplicationService.getOwnPersonalResidenceByApplicationID(fromDashboard ? appObjId : applicationId);
            const data = res?.data;
            if (Array.isArray(data)) {
                const mapped = res.data.map((item, idx) => ({
                    Id: item.Id,
                    RowID: idx + 1,
                    PropertyLocation: item.PropertyAndLocation,
                    Owner: item.Owner ?? null,
                    isBeneficialInterestAssigned: item.IsBeneficialInterestAssign ? "Yes" : "No",
                    beneficialInterestDetails: item.BeneficialInterestAssignWhome,
                    isObligatedOnDebt: item.IsDirectlyOrIndirectlyObligated ? "Yes" : "No",
                    obligatedDebtDetails: item.DirectlyOrIndirectlyObligatedWhome,
                    dateAcquired: item.DateAcquired ? item.DateAcquired : null,
                    cost: item.Cost,
                    marketValue: item.MarketValue,
                    mortgagor: item.Mortgagor,
                    maturity: item.Maturity ? item.Maturity : null,
                    amount: item.Amount,
                    uploadPath: item.Upload_Path,
                }));
                setAssets(mapped?.length > 0 ? mapped : []);
                setReownedCount(res.data.length);
            }
        } catch (error) {
            console.error(error);
        }
    };
    const getPathname = (url) => {
        try {
            return new URL(url).pathname;
        } catch {
            if (typeof url === "string") {
                return url;
            }
            console.warn("Invalid URL passed to getPathname:", url);
            return ""; // fallback to empty string to avoid crashing
        }
    };
    const handleSave = async (showMessage = true) => {
        setLoading(true);

        //below validations comment start
        // let isValid = true;
        // const newErrors = [];

        // assets.forEach((item) => {
        //     const safeTrim = (val) => (typeof val === 'string' ? val.trim() : '');
        //     const safeToString = (val) => (val !== null && val !== undefined ? val.toString().trim() : '');

        //     const errObj = {
        //         PropertyLocation: safeTrim(item.PropertyLocation) === '',
        //         Owner: safeTrim(item.Owner) === '',

        //         isBeneficialInterestAssigned: safeTrim(item.Owner) === 'Guarantor' && !item.isBeneficialInterestAssigned,

        //         beneficialInterestDetails:
        //             safeTrim(item.Owner) === 'Guarantor' &&
        //             item.isBeneficialInterestAssigned === 'Yes' &&
        //             safeTrim(item.beneficialInterestDetails) === '',

        //         isObligatedOnDebt:
        //             safeTrim(item.Owner) === 'Guarantor' &&
        //             !item.isObligatedOnDebt,

        //         obligatedDebtDetails:
        //             safeTrim(item.Owner) === 'Guarantor' &&
        //             item.isObligatedOnDebt === 'Yes' &&
        //             safeTrim(item.obligatedDebtDetails) === '',

        //         dateAcquired: item.dateAcquired == null,
        //         cost: safeToString(item.cost) === '',
        //         marketValue: safeToString(item.marketValue) === '',
        //         mortgagor: safeTrim(item.mortgagor) === '',
        //         maturity: item.maturity == null,
        //         amount: safeToString(item.amount) === '',
        //     };

        //     if (Object.values(errObj).some(Boolean)) {
        //         isValid = false;
        //     }

        //     newErrors.push(errObj);
        // });
        // setAssetErrors(newErrors);

        // if (!isValid) {
        //     setLoading(false);
        //     return false;
        // }
        //above validations comment end
        const payload = {
            ApplicationId: fromDashboard ? appObjId : applicationId,
            listownpersonalrecidance: assets.map((item) => ({
                Id: item.Id || 0,
                ApplicationId: fromDashboard ? appObjId : applicationId,
                PropertyAndLocation: item.PropertyLocation,
                Owner: item.Owner,
                DateAcquired: item.dateAcquired ? item.dateAcquired : null,
                Cost: item.cost,
                MarketValue: item.marketValue,
                Mortgagor: item.mortgagor,
                Maturity: item.maturity ? item.maturity : null,
                Amount: item.amount,
                IsBeneficialInterestAssign: item.isBeneficialInterestAssigned === "Yes",
                BeneficialInterestAssignWhome: item.beneficialInterestDetails || null,
                IsDirectlyOrIndirectlyObligated: item.isObligatedOnDebt === "Yes",
                DirectlyOrIndirectlyObligatedWhome: item.obligatedDebtDetails || null,
                Upload_Path: getPathname(item.uploadPath),
                CreatedBy: "",
                CreatedDate: new Date(),
                UpdatedBy: "",
                UpdatedDate: new Date(),
            })),
        };
        try {
            const res = await _NewapplicationService.addOrUpdateOwnPersonalResidence(payload);
            if (res?.data.IsSuccess) {
                setLoading(false);
                message.success(res.data.Message);
                fetchAssets();
            } else {
                setLoading(false);
                message.error(res.data.Message ? res.data.Message : COMMON_ERROR_MSG);
            }
        } catch (err) {
            setLoading(false);
            message.error(err.message || SUBMISSION_FAILED);
        }
    };
    const handleChangeVestedIntrestPension = (idx, field, value) => {
        const updated = [...VestedInterest];
        updated[idx][field] = value;
        setVestedInterest(updated);
    };

    const handleSaveVestedIntrestPension = async (showMessage = true) => {
        setLoading(true);
        //below validation comment start
        // let isValid = true;
        // const newErrors = [];
        // VestedInterest.forEach((item) => {
        //     const errObj = {
        //         NameOfCompanyErr: !item.NameofCompany?.trim(),
        //         OwnerErr: !item.Owner,
        //         BeneficiaryErr: !item.Beneficiary,
        //         PayoutBasisErr: !item.PayoutBasis?.trim(),
        //         AmountErr: !item.Amount,
        //         DateAvailableErr: !item.DateAvailable,
        //     };

        //     if (Object.values(errObj).some(Boolean)) {
        //         isValid = false;
        //     }
        //     newErrors.push(errObj);
        // });

        // setVestedInterestErrors(newErrors);

        // if (!isValid) {
        //     setLoading(false);
        //     return false;
        // }
        //above validation comment end

        const payload = {
            ApplicationId: fromDashboard ? appObjId : applicationId,
            listvested: VestedInterest.map((item) => ({
                Id: item.Id || 0,
                ApplicationId: fromDashboard ? appObjId : applicationId,
                NameOfCompany: item.NameofCompany,
                Owner: item.Owner,
                Beneficiary: item.Beneficiary,
                PayoutBasis: item.PayoutBasis,
                AvailableDate: item.DateAvailable ? item.DateAvailable : null,
                Amount: item.Amount,
                CreatedBy: "",
                CreatedDate: new Date(),
                UpdatedBy: "",
                UpdatedDate: new Date(),
            })),
        };
        try {
            const res = await _NewapplicationService.addOrUpdateVestedIntrestPension(payload);
            if (res.data.IsSuccess) {
                setLoading(false);
                message.success(res.data.Message);
                fetchVestedIntrestPensionData();
            } else {
                setLoading(false);
                message.error(res.data.Message ? res.data.Message : COMMON_ERROR_MSG);
            }
        } catch (err) {
            setLoading(false);
            message.error(err.message || SUBMISSION_FAILED);
        }
    };

    const fetchVestedIntrestPensionData = async () => {
        try {
            const res = await _NewapplicationService.getVestedIntrestPensionByApplicationID(
                fromDashboard ? appObjId : applicationId
            );

            const data = res?.data;

            if (Array.isArray(data)) {
                const mappedData = data.map((item) => ({
                    Id: item.Id,
                    NameofCompany: item.NameOfCompany,
                    Owner: item.Owner,
                    Beneficiary: item.Beneficiary,
                    PayoutBasis: item.PayoutBasis,
                    DateAvailable: item.AvailableDate ? item.AvailableDate : null,
                    Amount: item.Amount,
                }));
                setVestedInterest(mappedData.length > 0 ? mappedData : []);
            }
        } catch (err) {
            console.error("Error fetching vested interest data:", err);
            // message.error("Failed to load data");
        }
    };

    const handleChangeUnlistedStocks = (index, field, value) => {
        const updated = [...UnlistedStocks];
        updated[index][field] = value;
        setUnlistedStocks(updated);
    };
    const handleSaveUnlistedStocks = async (showMessage = true) => {
        setLoading(true);

        // below validation comment start
        // let isValid = true;
        // const newErrors = [];
        // UnlistedStocks.forEach((item) => {
        //     const errorObj = {
        //         DescriptionOfSecuritiesErr: !item.DescriptionOfSecurities?.trim(),
        //         InNameOfErr: !item.InNameOf?.toString().trim(),
        //         OwnershipErr: !item.Ownership?.toString().trim(),
        //         BookValueErr: !item.BookValue?.toString().trim(),
        //         BookValueAmountErr: !item.BookValueAmount?.toString().trim(),
        //         IfPledgedTowhomErr: !item.IfPledgedTowhom?.trim(),
        //     };

        //     if (Object.values(errorObj).some(Boolean)) {
        //         isValid = false;
        //     }

        //     newErrors.push(errorObj);
        // });
        // setUnlistedStockErrors(newErrors);
        // if (!isValid) {
        //     setLoading(false);
        //     return false;
        // }
        // above validation comment end

        const payload = {
            ApplicationId: fromDashboard ? appObjId : applicationId,
            listunlistedtstock: UnlistedStocks.map((item) => ({
                Id: item.Id || 0,
                ApplicationId: fromDashboard ? appObjId : applicationId,
                DescriptionOfSecurity: item.DescriptionOfSecurities,
                InNameOf: item.InNameOf,
                OwenershipPercentage: item.Ownership,
                BookValue: item.BookValue,
                BookValueAmount: item.BookValueAmount,
                PledgeToWhome: item.IfPledgedTowhom
            })),
        };
        try {
            const res = await _NewapplicationService.addOrUpdateUnListedStocks(payload);
            if (res.data.IsSuccess) {
                setLoading(false);
                if (showMessage) {
                    message.success(res.data.Message);
                }
                fetchUnlistedStocksData();
                return true
            } else {
                setLoading(false);
                message.error(res.data.Message ? res.data.Message : COMMON_ERROR_MSG);
                return false;
            }
        } catch (err) {
            setLoading(false);
            message.error(err.message || SUBMISSION_FAILED);
            return false;
        }
    };

    const fetchUnlistedStocksData = async () => {
        try {
            const res = await _NewapplicationService.getUnListedStocksByApplicationID(
                fromDashboard ? appObjId : applicationId
            );

            const data = res?.data;
            if (Array.isArray(data)) {
                const mappedUnListedStocksData = data.map((item) => ({
                    Id: item.Id,
                    DescriptionOfSecurities: item.DescriptionOfSecurity,
                    InNameOf: item.InNameOf,
                    Ownership: item.OwenershipPercentage,
                    BookValue: item.BookValue,
                    BookValueAmount: item.BookValueAmount,
                    IfPledgedTowhom: item.PledgeToWhome,
                }));
                setUnlistedStocks(mappedUnListedStocksData.length > 0 ? mappedUnListedStocksData : []);
            }
        } catch (err) {
            console.log(err);
            // message.error("Failed to load data");
        }
    };

    const handleChangeReInvestment = (idx, field, value) => {
        const updated = [...ReInvestmentsAssets];
        updated[idx][field] = value;
        setReInvestmentsAssets(updated);
    };
    const saveReInvestmentData = async (showMessage = true) => {
        setLoading(true);
        // below validation comment start
        // let isValid = true;
        // const newErrors = [];

        // ReInvestmentsAssets.forEach((item) => {
        //     const safeTrim = (val) => (typeof val === 'string' ? val.trim() : '');
        //     const safeToString = (val) =>
        //         val !== null && val !== undefined ? val.toString().trim() : '';

        //     const errObj = {
        //         PropertyLocationErr: safeTrim(item.PropertyLocation) === '',
        //         OwnerErr: safeTrim(item.Owner) === '',
        //         isBeneficialInterestAssignedErr:
        //             item.Owner === 'Guarantor' && safeTrim(item.isBeneficialInterestAssigned) === '',
        //         beneficialInterestDetailsErr:
        //             item.Owner === 'Guarantor' && item.isBeneficialInterestAssigned === 'Yes' && safeTrim(item.beneficialInterestDetails) === '',
        //         isObligatedOnDebtErr:
        //             item.Owner === 'Guarantor' && safeTrim(item.isObligatedOnDebt) === '',
        //         obligatedDebtDetailsErr:
        //             item.Owner === 'Guarantor' && item.isObligatedOnDebt === 'Yes' && safeTrim(item.obligatedDebtDetails) === '',
        //         dateAcquiredErr: !item.dateAcquired,
        //         costErr: safeToString(item.cost) === '',
        //         marketValueErr: safeToString(item.marketValue) === '',
        //         mortgagorErr: safeTrim(item.mortgagor) === '',
        //         maturityErr: !item.maturity,
        //         amountErr: safeToString(item.amount) === '',
        //     };
        //     if (Object.values(errObj).some(Boolean)) {
        //         isValid = false;
        //     }

        //     newErrors.push(errObj);
        // });

        // setReInvestmentErrors(newErrors);
        // if (!isValid) {
        //     setLoading(false);
        //     return false;
        // }
        // above validation comment end

        const payload = {
            ApplicationId: fromDashboard ? appObjId : applicationId,
            listinvestment: ReInvestmentsAssets.map((item) => ({
                Id: item.Id || 0,
                ApplicationId: fromDashboard ? appObjId : applicationId,
                PropertyAndLocation: item.PropertyLocation,
                Owner: item.Owner,
                DateAcquired: item.dateAcquired || null,
                Cost: item.cost,
                MarketValue: item.marketValue,
                Mortgagor: item.mortgagor,
                Maturity: item.maturity || null,
                Amount: item.amount,
                IsBeneficialInterestAssign: item.isBeneficialInterestAssigned === "Yes",
                BeneficialInterestAssignWhome: item.beneficialInterestDetails || null,
                IsDirectlyOrIndirectlyObligated: item.isObligatedOnDebt === "Yes",
                DirectlyOrIndirectlyObligatedWhome: item.obligatedDebtDetails || null,
                Upload_Path: item.Upload_Path || null
            })),
        };

        try {
            const res = await _NewapplicationService.addOrUpdateInvestment(payload);
            if (res.data.IsSuccess) {
                setLoading(false);
                if (showMessage) {
                    message.success(res.data.Message);
                }
                fetchReInvestmentData();
                return true;
            } else {
                setLoading(false);
                message.error(res.data.Message ? res.data.Message : COMMON_ERROR_MSG);
                return false;
            }
        } catch (err) {
            setLoading(false);
            message.error(err.message || SUBMISSION_FAILED);
            return false;

        }
    };

    const fetchReInvestmentData = async () => {
        try {
            const res = await _NewapplicationService.getInvestmentByApplicationID(
                fromDashboard ? appObjId : applicationId
            );

            const data = res?.data;

            if (Array.isArray(data)) {
                const mappedData = data.map((item) => ({
                    Id: item.Id,
                    PropertyLocation: item.PropertyAndLocation || "",
                    Owner: item.Owner || "",
                    dateAcquired: item.DateAcquired ? item.DateAcquired : null,
                    cost: item.Cost || "",
                    marketValue: item.MarketValue || "",
                    mortgagor: item.Mortgagor || "",
                    maturity: item.Maturity ? item.Maturity : null,
                    amount: item.Amount || "",
                    isBeneficialInterestAssigned: item.IsBeneficialInterestAssign ? "Yes" : "No",
                    beneficialInterestDetails: item.BeneficialInterestAssignWhome || "",
                    isObligatedOnDebt: item.IsDirectlyOrIndirectlyObligated ? "Yes" : "No",
                    obligatedDebtDetails: item.DirectlyOrIndirectlyObligatedWhome || "",
                    uploadPath: item.Upload_Path || ""
                }));

                setReInvestmentsAssets(mappedData.length > 0 ? mappedData : []);
            }
        } catch (err) {
            console.log("Error fetching Re-Investment data:", err);
        }
    };

    const handleGeneralInterestChange = (idx, field, value) => {
        const updated = [...generalInterest];
        updated[idx][field] = value;
        setGeneralInterest(updated);
    };
    const saveGeneralInterest = async (showMessage = true) => {
        setLoading(true);
        // below validation comment start
        // const validationErrors = [];
        // let isValid = true;
        // generalInterest.forEach((item, idx) => {
        //     const errObj = {
        //         NameofPartnershipErr: !item.NameofPartnership?.trim(),
        //         TypeofInvestmentErr: !item.TypeofInvestment,
        //         LimitedorGeneralErr: !item.LimitedorGeneral,
        //         AmountInvestedErr: !item.AmountInvested?.toString().trim(),
        //         FairMarketValueofPartnershipInterestErr: !item.FairMarketValueofPartnershipInterest?.toString().trim(),
        //     };

        //     validationErrors.push(errObj);

        //     if (Object.values(errObj).some(Boolean)) {
        //         isValid = false;
        //     }
        // });

        // setGeneralInterestErrors(validationErrors);

        // if (!isValid) {
        //     setLoading(false);
        //     return false;
        // }
        // above validation comment end

        const payload = {
            ApplicationId: fromDashboard ? appObjId : applicationId,
            listgenrallimitedpartnership: generalInterest.map((item) => ({
                Id: item.Id ?? 0,
                ApplicationId: fromDashboard ? appObjId : applicationId,
                NameOfPartenership: item.NameofPartnership,
                TypeOfInvestment: item.TypeofInvestment,
                LimitedOrGeneral: item.LimitedorGeneral,
                AmountInvested: item.AmountInvested,
                FairMarketValue: item.FairMarketValueofPartnershipInterest,
                Upload_Path: getPathname(item.uploadPath)
            })),
        };
        try {
            const res = await _NewapplicationService.addOrUpdateGeneralAndLimitedPartenership(payload);
            if (res.data.IsSuccess) {
                setLoading(false);
                if (showMessage) {
                    message.success(res.data.Message);
                }
                fetchGeneralInterestData();
                return true;
            } else {
                setLoading(false);
                message.error(res.data.Message ? res.data.Message : COMMON_ERROR_MSG);
                return false;
            }
        } catch (err) {
            setLoading(false);
            console.log(err)
            return false;
            //message.error(err || SUBMISSION_FAILED);
        }
    };

    const fetchGeneralInterestData = async () => {
        try {
            const res = await _NewapplicationService.getGeneralAndLimitedPartenershipByApplicationID(fromDashboard ? appObjId : applicationId);
            if (Array.isArray(res.data)) {
                const mapped = res.data.map((item, idx) => ({
                    Id: item.Id,
                    RowID: idx + 1,
                    NameofPartnership: item.NameOfPartenership,
                    TypeofInvestment: item.TypeOfInvestment,
                    LimitedorGeneral: item.LimitedOrGeneral,
                    AmountInvested: item.AmountInvested,
                    FairMarketValueofPartnershipInterest: item.FairMarketValue,
                    uploadPath: item.Upload_Path,
                }));
                setGeneralInterest(mapped);
                setgeneralPartnershipCount(res.data.length);
            }
        } catch (error) {
            console.log(error);
            //message.error("Failed to fetch partnership data");
        }
    };
    useEffect(() => form.resetFields(), [balancesheettotalassetInfo]);
    const handleValuesChange = (changedValues, allValues) => {
        const total = Object.entries(allValues).reduce((acc, [key, value]) => {
            if (key === 'totalLiquidMarketableAssets') return acc;
            const num = parseFloat(value);
            return acc + (isNaN(num) ? 0 : num);
        }, 0);
        form.setFieldsValue({
            totalLiquidMarketableAssets: total,
        });

        // setBalancesheettotalassetInfo({
        //     ...allValues,
        //     totalLiquidMarketableAssets: total,
        // });
    };
    const handleFileUpload = async (file, idx, currentIndex) => {
        const MAX_SIZE = 500 * 1024;
        if (file.size > MAX_SIZE) {
            message.error("File size should not exceed 500 KB.");
            return;
        }

        setLoading(true);
        const formData = new FormData();
        formData.append("file", file);
        const fieldName = "balancesheettotalassetreown";
        const appId = fromDashboard ? appObjId : applicationId;
        const RowIndexId = idx;
        try {
            const res = await _NewapplicationService.UploadPdfOrDocFileRowId(formData, appId, fieldName, RowIndexId);
            const result = res?.data;
            if (result.IsSucess && result?.URL) {
                const fullUrl = new URL(result.URL);
                const relativePath = fullUrl.pathname.slice(1);
                handleChange(currentIndex, "uploadPath", relativePath);
                handleChange(currentIndex, "fullUrl", fullUrl);
                setLoading(false);
                message.success(result.Message);
            } else {
                setLoading(false);
                console.error("Upload failed:", result);
            }
        } catch (error) {
            setLoading(false);
            console.error("Upload error:", error);
        }
    };
    const handleFileUploadCapitalAccount = async (file, idx, currentIndex) => {
        const MAX_SIZE = 500 * 1024;
        if (file.size > MAX_SIZE) {
            message.error("File size should not exceed 500 KB.");
            return;
        }
        setLoading(true);
        const formData = new FormData();
        formData.append("file", file);
        const fieldName = "balancesheettotalassetcapitalacc";
        const appId = fromDashboard ? appObjId : applicationId;
        const RowIndexId = idx;
        try {
            const res = await _NewapplicationService.UploadPdfOrDocFileRowId(formData, appId, fieldName, RowIndexId);
            const result = res?.data;
            if (result.IsSucess && result?.URL) {
                const fullUrl = new URL(result.URL);
                const relativePath = fullUrl.pathname.slice(1);
                handleGeneralInterestChange(currentIndex, "uploadPath", relativePath);
                handleGeneralInterestChange(currentIndex, "fullUrl", fullUrl);
                setLoading(false);
                message.success(result.Message);
            } else {
                setLoading(false);
                message.error(result.Message);
                console.error("Upload failed:", result);
            }
        } catch (error) {
            setLoading(false);
            console.error("Upload error:", error);
        }
    };
    const onDeleteImage = (idx) => {
        confirm({
            title: "Are you sure you want to delete this file?",
            icon: <ExclamationCircleOutlined />,
            okText: <span id="yesBtn">Yes</span>,
            cancelText: <span id="noBtn">No</span>,
            okType: "primary",
            onOk() {
                onCancelImage(idx); // Pass index
            }
        });
    };

    const onCancelImage = (idx) => {
        const updatedAssets = [...assets];
        updatedAssets[idx].uploadPath = "";
        setAssets(updatedAssets);

    };
    const onDeleteCapitalAccountImage = (idx) => {
        confirm({
            title: "Are you sure you want to delete this file?",
            icon: <ExclamationCircleOutlined />,
            okText: <span id="yesBtn">Yes</span>,
            cancelText: <span id="noBtn">No</span>,
            okType: "primary",
            onOk() {
                onCancelCapitalAccountImage(idx); // Pass index
            }
        });
    };
    const onCancelCapitalAccountImage = (idx) => {
        const updatedAssets = [...generalInterest];
        updatedAssets[idx].uploadPath = "";
        setGeneralInterest(updatedAssets);
    };

    console.log(assets, "assets test");
    return (
        <Spin spinning={loading}>
            <LeftLayout>
                {/* {applicationId && applicationId !== 'undefined' && applicationId !== 'null' && (
                    <div style={{
                        position: "absolute",
                        top: 5,
                        right: 20,
                        margin: 0,
                        zIndex: 1000,
                        maxWidth: "1000px",
                        padding: "8px 16px",
                    }}>
                       <ApplicationProgressBar />
                        <Title level={3} style={{ margin: 0 }}>
                            <ShowApplicationId />
                        </Title>
                    </div>
                )} */}
                <div>
                    {applicationId && applicationId !== 'undefined' && applicationId !== 'null' && (
                        <div>
                            <ApplicationProgressBar />
                            <Title level={5}>
                                {/* <ShowApplicationId /> */}
                            </Title>
                        </div>
                    )}
                </div>
                <div className="pageSubBackgroundForBalanceAssetPageWrapper">
                    <div className="pageSubBackgroundForBalanceAssetPageCard">
                        <Row align="top" className="balance-sheet-total-assets-wrapper balance-w">
                            <Col span={24}>
                                <Title level={3}>Balance Sheet -Total Assets </Title>
                                <Form
                                    form={form}
                                    layout="vertical"
                                    onFinish={onFinish}
                                    className="addMultipleRowForm"
                                    initialValues={balancesheettotalassetInfo}
                                    onValuesChange={handleValuesChange}
                                >
                                    <Card className="mb15 BalSheetcardView">
                                        <Collapse accordion expandIconPosition="end"
                                            ghost
                                            expandIcon={({ isActive }) => (
                                                <span style={{ color: '#1890ff', fontWeight: 'bold' }}>
                                                    {isActive ? 'Hide Details' : 'Add Details'}
                                                </span>
                                            )}
                                        >
                                            <CollapsePanel
                                                key="1"
                                                collapsible="icon"
                                                header={
                                                    <Row justify="space-between" align="middle" style={{ width: "100%" }}>
                                                        <Col className="left-balance">
                                                            <label className="f16Bold">RE Owned - Personal Residence (S)

                                                            </label>
                                                        </Col>
                                                        <Col className="right-balance">
                                                            <Form.Item name="ownPersonalResidenceTotal"
                                                                // rules={[
                                                                //     {
                                                                //         required: true,
                                                                //         message: "RE Owned - Personal Residence (S) is required"
                                                                //     }]}
                                                                style={{ marginBottom: 0 }}>
                                                                <CurrencyInput placeholder="Enter Amount" />
                                                            </Form.Item>
                                                        </Col>
                                                    </Row>
                                                }
                                            >

                                                {assets.map((asset, idx) => (
                                                    <div key={idx} className="balancesheetpdm">
                                                        <Row justify="end">
                                                            {idx > 0 && (
                                                                <Button
                                                                    type="text"
                                                                    icon={<DeleteOutlined style={{ fontSize: 18 }} />}
                                                                    onClick={() => deleteReOwnedPersonalResidences(idx)}
                                                                />
                                                            )}
                                                        </Row>

                                                        <Form.Item label="Property & Location" className="w50">
                                                            <Input
                                                                placeholder="Enter Property & Location"
                                                                value={asset.PropertyLocation}
                                                                onChange={(e) => handleChange(idx, "PropertyLocation", e.target.value)}
                                                            />
                                                            {/* {assetErrors[idx]?.PropertyLocation && (
                                                        <div className="ant-form-item-explain-error">Property & Location is required</div>
                                                    )} */}
                                                        </Form.Item>

                                                        <Form.Item label="Owner" className="w50">
                                                            <Input
                                                                placeholder="Enter Owner"
                                                                value={asset.Owner || ''}
                                                                onChange={(e) => handleChange(idx, "Owner", e.target.value)}
                                                            />

                                                            {/* {assetErrors[idx]?.Owner && (
                                                        <div className="ant-form-item-explain-error">Owner is required</div>
                                                    )} */}
                                                        </Form.Item>

                                                        {asset.Owner === "Guarantor" && (
                                                            <>
                                                                <Form.Item label="1. Is Beneficial Interest Assigned?" className="w50">
                                                                    <Radio.Group
                                                                        value={asset.isBeneficialInterestAssigned}
                                                                        onChange={(e) => handleChange(idx, "isBeneficialInterestAssigned", e.target.value)}
                                                                    >
                                                                        <Radio value="Yes">Yes</Radio>
                                                                        <Radio value="No">No</Radio>
                                                                    </Radio.Group>
                                                                    {/* {assetErrors[idx]?.isBeneficialInterestAssigned && (
                                                                <div className="ant-form-item-explain-error">Select if beneficial interest is assigned</div>
                                                            )} */}
                                                                </Form.Item>

                                                                {asset.isBeneficialInterestAssigned === "Yes" && (
                                                                    <Form.Item label="To Whom?" className="w50">
                                                                        <Input
                                                                            placeholder="Enter To Whom"
                                                                            value={asset.beneficialInterestDetails}
                                                                            onChange={(e) => handleChange(idx, "beneficialInterestDetails", e.target.value)}
                                                                        />
                                                                        {/* {assetErrors[idx]?.beneficialInterestDetails && (
                                                                    <div className="ant-form-item-explain-error">Please specify to whom</div>
                                                                )} */}
                                                                    </Form.Item>
                                                                )}

                                                                <Form.Item label="2. Are you directly or indirectly obligated on the debt?" className="w50">
                                                                    <Radio.Group
                                                                        value={asset.isObligatedOnDebt}
                                                                        onChange={(e) => handleChange(idx, "isObligatedOnDebt", e.target.value)}
                                                                    >
                                                                        <Radio value="Yes">Yes</Radio>
                                                                        <Radio value="No">No</Radio>
                                                                    </Radio.Group>
                                                                    {/* {assetErrors[idx]?.isObligatedOnDebt && (
                                                                <div className="ant-form-item-explain-error">Select if obligated on the debt</div>
                                                            )} */}
                                                                </Form.Item>

                                                                {asset.isObligatedOnDebt === "Yes" && (
                                                                    <Form.Item label="To Whom?" className="w50">
                                                                        <Input
                                                                            placeholder="Enter To Whom"
                                                                            value={asset.obligatedDebtDetails}
                                                                            onChange={(e) => handleChange(idx, "obligatedDebtDetails", e.target.value)}
                                                                        />
                                                                        {/* {assetErrors[idx]?.obligatedDebtDetails && (
                                                                    <div className="ant-form-item-explain-error">Please specify to whom</div>
                                                                )} */}
                                                                    </Form.Item>
                                                                )}
                                                            </>
                                                        )}

                                                        <Form.Item label="Date Acquired" className="w50">
                                                            <DatePicker
                                                                value={asset.dateAcquired ? moment(asset.dateAcquired, "YYYY-MM-DD") : null}
                                                                onChange={(date) => handleChange(idx, "dateAcquired", date?.format("YYYY-MM-DD"))}
                                                                format="MM/DD/YYYY"
                                                                style={{ width: "100%" }}
                                                                disabledDate={(current) => current && current.isAfter(moment(), "day")}
                                                            />
                                                            {/* {assetErrors[idx]?.dateAcquired && (
                                                        <div className="ant-form-item-explain-error">Date Acquired is required</div>
                                                    )} */}
                                                        </Form.Item>

                                                        <Form.Item label="Market Value" className="w50">
                                                            {/* <Input
                                                        value={asset.marketValue}
                                                        onChange={(e) => handleChange(idx, "marketValue", e.target.value)}
                                                    /> */}
                                                            <CurrencyInput
                                                                placeholder="Enter Market Value"
                                                                value={asset.marketValue}
                                                                onChange={(val) => handleChange(idx, "marketValue", val)}
                                                            />
                                                            {/* {assetErrors[idx]?.marketValue && (
                                                        <div className="ant-form-item-explain-error">Market Value is required</div>
                                                    )} */}
                                                        </Form.Item>
                                                        <Form.Item
                                                            label="Upload (Schedule of RE)"
                                                        >
                                                            {/* Show existing image if available */}
                                                            {asset.uploadPath ? (
                                                                <div id="imgDiv" className="imgDiv mb10">
                                                                    <Tooltip title="Download">
                                                                        <a
                                                                            href={asset.fullUrl ? asset.fullUrl : asset.uploadPath}
                                                                            target="_blank"
                                                                            rel="noopener noreferrer"
                                                                            download // triggers download behavior in supported browsers
                                                                        >
                                                                            <FileOutlined />
                                                                            {asset.uploadPath.split('/').pop().split('?')[0] ? "Schedule of RE" : null}
                                                                        </a>
                                                                    </Tooltip>

                                                                    <Tooltip title="Delete">
                                                                        <Button
                                                                            id="deleteLogoBtn"
                                                                            type="text"
                                                                            icon={<DeleteOutlined />}
                                                                            danger
                                                                            onClick={() => onDeleteImage(idx)}
                                                                        />
                                                                    </Tooltip>

                                                                </div>
                                                            ) : (
                                                                // Show upload component if no existing image or image has been deleted
                                                                <Upload
                                                                    accept=".pdf,.doc,.docx"
                                                                    listType="text"
                                                                    maxCount={1}
                                                                    showUploadList={false}
                                                                    customRequest={({ file, onSuccess }) => {
                                                                        handleFileUpload(file, asset.RowID, idx);
                                                                        onSuccess("ok");
                                                                    }}
                                                                >
                                                                    <Button icon={<UploadOutlined />}>Click to Upload</Button>
                                                                </Upload>
                                                            )}
                                                        </Form.Item>

                                                        <Divider></Divider>


                                                        <Form.Item label="Cost" className="w50 displayNone">
                                                            {/* <Input
                                                        value={asset.cost}
                                                        onChange={(e) => handleChange(idx, "cost", e.target.value)}
                                                    /> */}
                                                            <CurrencyInput
                                                                placeholder="Enter Cost"
                                                                value={asset.cost}
                                                                onChange={(val) => handleChange(idx, "cost", val)}
                                                            />
                                                            {/* {assetErrors[idx]?.cost && (
                                                        <div className="ant-form-item-explain-error">Cost is required</div>
                                                    )} */}
                                                        </Form.Item>



                                                        <Form.Item label="Mortgagor" className="w50">
                                                            <Input
                                                                placeholder="Enter Mortgagor"
                                                                value={asset.mortgagor}
                                                                onChange={(e) => handleChange(idx, "mortgagor", e.target.value)}
                                                            />
                                                            {/* {assetErrors[idx]?.mortgagor && (
                                                        <div className="ant-form-item-explain-error">Mortgagor is required</div>
                                                    )} */}
                                                        </Form.Item>

                                                        <Form.Item label="Maturity Date" className="w50">
                                                            <DatePicker
                                                                format="MM/DD/YYYY"
                                                                value={asset.maturity ? moment(asset.maturity, "YYYY-MM-DD") : null}
                                                                onChange={(date) => handleChange(idx, "maturity", date?.format("YYYY-MM-DD"))}
                                                                style={{ width: "100%" }}
                                                                disabledDate={(current) => current && current.isBefore(moment(), "day")}
                                                            />
                                                            {/* {assetErrors[idx]?.maturity && (
                                                        <div className="ant-form-item-explain-error">Maturity Date is required</div>
                                                    )} */}
                                                        </Form.Item>

                                                        <Form.Item label="Amount" className="w50">
                                                            {/* <Input
                                                        value={asset.amount}
                                                        onChange={(e) => handleChange(idx, "amount", e.target.value)}
                                                    /> */}
                                                            <CurrencyInput
                                                                placeholder="Enter Amount"
                                                                value={asset.amount}
                                                                onChange={(val) => handleChange(idx, "amount", val)}
                                                            />
                                                            {/* {assetErrors[idx]?.amount && (
                                                        <div className="ant-form-item-explain-error">Amount is required</div>
                                                    )} */}
                                                        </Form.Item>


                                                    </div>
                                                ))}

                                                <Form.Item style={{ textAlign: "right" }}>
                                                    <Button
                                                        type="link"
                                                        icon={<PlusCircleOutlined />}
                                                        onClick={addReOwnedPersonalResidences}
                                                        className="f16"
                                                        disabled={![1,2,4,9].includes(balancesheettotalassetInfo && balancesheettotalassetInfo.Application_Status_Id) ? true : false}
                                                    >
                                                        Add More
                                                    </Button>
                                                    <Button
                                                        type="primary"
                                                        onClick={() => handleSave(true)}
                                                        disabled={![1,2,4,9].includes(balancesheettotalassetInfo && balancesheettotalassetInfo.Application_Status_Id) ? true : false}
                                                    >
                                                        Save
                                                    </Button>
                                                </Form.Item>

                                            </CollapsePanel>
                                        </Collapse>
                                    </Card>

                                    <Card className="mb15 BalSheetcardView">
                                        <Collapse accordion expandIconPosition="end"
                                            ghost
                                            expandIcon={({ isActive }) => (
                                                <span style={{ color: '#1890ff', fontWeight: 'bold' }}>
                                                    {isActive ? 'Hide Details' : 'Add Details'}
                                                </span>
                                            )}>
                                            <CollapsePanel
                                                key="1"
                                                collapsible="icon"
                                                header={
                                                    <Row justify="space-between" align="middle" style={{ width: "100%" }}>
                                                        <Col className="left-balance">
                                                            <label className="f16Bold">Vested Interest in Pension/Profit Share/Deferred Comp
                                                            </label>
                                                        </Col>
                                                        <Col className="right-balance">
                                                            <Form.Item name="vestedIntrestPensionTotal"
                                                                // rules={[
                                                                //     {
                                                                //         required: true,
                                                                //         message: "Vested Interest in Pension/Profit Share/Deferred Comp  is required"
                                                                //     }]}
                                                                style={{ marginBottom: 0 }}>
                                                                <CurrencyInput placeholder="Enter Amount" />
                                                            </Form.Item>
                                                        </Col>
                                                    </Row>
                                                }
                                            >

                                                {VestedInterest.map((vested, idx) => (
                                                    <div key={idx} className="balancesheetpdm">
                                                        <Row justify="end">
                                                            {idx > 0 && (
                                                                <Button
                                                                    type="text"
                                                                    icon={<DeleteOutlined style={{ fontSize: 18 }} />}
                                                                    onClick={() => deleteVestedInterest(idx)}
                                                                />
                                                            )}
                                                        </Row>

                                                        <Form.Item label="Name Of Company" className="w50">
                                                            <Input
                                                                placeholder="Enter Name Of Company"
                                                                value={vested.NameofCompany}
                                                                onChange={(e) => handleChangeVestedIntrestPension(idx, "NameofCompany", e.target.value)}
                                                            />
                                                            {/* {vestedInterestErrors[idx]?.NameOfCompanyErr && (
                                                        <div className="ant-form-item-explain-error">Name Of Company is required</div>
                                                    )} */}
                                                        </Form.Item>

                                                        <Form.Item label="Owner" className="w50">
                                                            <Input
                                                                placeholder="Enter Owner"
                                                                value={vested.Owner || ''}
                                                                onChange={(e) => handleChangeVestedIntrestPension(idx, "Owner", e.target.value)}
                                                            />
                                                            {/* {vestedInterestErrors[idx]?.OwnerErr && (
                                                        <div className="ant-form-item-explain-error">Owner is required</div>
                                                    )} */}
                                                        </Form.Item>

                                                        <Form.Item label="Beneficiary" className="w50">
                                                            <Input
                                                                placeholder="Enter Beneficiary"
                                                                value={vested.Beneficiary}
                                                                onChange={(e) => handleChangeVestedIntrestPension(idx, "Beneficiary", e.target.value)}
                                                            />
                                                            {/* {vestedInterestErrors[idx]?.BeneficiaryErr && (
                                                        <div className="ant-form-item-explain-error">Beneficiary is required</div>
                                                    )} */}
                                                        </Form.Item>

                                                        <Form.Item label="Payout Basis" className="w50">
                                                            <CurrencyInput
                                                                placeholder="Enter Payout Basis"
                                                                value={vested.PayoutBasis}
                                                                onChange={(val) => handleChangeVestedIntrestPension(idx, "PayoutBasis", val)}
                                                            />
                                                            {/* {vestedInterestErrors[idx]?.PayoutBasisErr && (
                                                        <div className="ant-form-item-explain-error">Payout Basis is required</div>
                                                    )} */}
                                                        </Form.Item>

                                                        <Form.Item label="Date Available" className="w50">
                                                            <DatePicker
                                                                value={vested.DateAvailable ? moment(vested.DateAvailable, "YYYY-MM-DD") : null}
                                                                onChange={(date) => handleChangeVestedIntrestPension(idx, "DateAvailable", date?.format("YYYY-MM-DD"))}
                                                                format="MM/DD/YYYY"
                                                                style={{ width: "100%" }}
                                                                disabledDate={(current) => current && current.isAfter(moment(), "day")}
                                                            />
                                                            {/* {vestedInterestErrors[idx]?.DateAvailableErr && (
                                                        <div className="ant-form-item-explain-error">Date Available is required</div>
                                                    )} */}
                                                        </Form.Item>

                                                        <Form.Item label="Amount" className="w50">
                                                            {/* <Input
                                                        value={vested.Amount}
                                                        onChange={(e) => handleChangeVestedIntrestPension(idx, "Amount", e.target.value)}
                                                    /> */}
                                                            <CurrencyInput
                                                                placeholder="Enter Amount"
                                                                value={vested.Amount}
                                                                onChange={(val) => handleChangeVestedIntrestPension(idx, "Amount", val)}
                                                            />
                                                            {/* {vestedInterestErrors[idx]?.AmountErr && (
                                                        <div className="ant-form-item-explain-error">Amount is required</div>
                                                    )} */}
                                                        </Form.Item>
                                                    </div>
                                                ))}

                                                <Form.Item style={{ textAlign: "right" }}>
                                                    <Button
                                                        type="link"
                                                        icon={<PlusCircleOutlined />}
                                                        className="f16"
                                                        onClick={addVestedInterest}
                                                        disabled={![1,2,4,9].includes(balancesheettotalassetInfo && balancesheettotalassetInfo.Application_Status_Id) ? true : false}
                                                    >
                                                        Add More
                                                    </Button>
                                                    <Button
                                                        type="primary"
                                                        onClick={handleSaveVestedIntrestPension}
                                                        disabled={![1,2,4,9].includes(balancesheettotalassetInfo && balancesheettotalassetInfo.Application_Status_Id) ? true : false}
                                                    >
                                                        Save
                                                    </Button>
                                                </Form.Item>

                                            </CollapsePanel>
                                        </Collapse>
                                    </Card>

                                    <Row className="card-section mb15">
                                        <Col className="left-balance">
                                            <label className="f16Bold">IRA/Keogh Accounts </label>
                                        </Col>
                                        <Col className="right-balance">
                                            <Form.Item
                                                name="iraKeoghAccountsTotal"
                                            // rules={[
                                            //     {
                                            //         required: true,
                                            //         message: "IRA/Keogh Accounts  is required"
                                            //     }]}
                                            >
                                                <CurrencyInput placeholder="Enter Amount" />
                                            </Form.Item>
                                        </Col>
                                    </Row>

                                    <Card className="mb15 BalSheetcardView">
                                        <Collapse accordion
                                            expandIconPosition="end"
                                            ghost
                                            expandIcon={({ isActive }) => (
                                                <span style={{ color: '#1890ff', fontWeight: 'bold' }}>
                                                    {isActive ? 'Hide Details' : 'Add Details'}
                                                </span>
                                            )}>
                                            <CollapsePanel
                                                key="1"
                                                collapsible="icon"
                                                header={
                                                    <Row justify="space-between" align="middle" style={{ width: "100%" }}>
                                                        <Col className="left-balance">
                                                            <label className="f16Bold">Unlisted Stocks - Total Accounts and Notes Receivable

                                                            </label>
                                                        </Col>
                                                        <Col className="right-balance">
                                                            <Form.Item name="unListedStocksAndAccountsTotal"
                                                            // rules={[
                                                            //     {
                                                            //         required: true,
                                                            //         message: "Unlisted Stocks - Total Accounts and Notes Receivable  is required"
                                                            //     }]}
                                                            >
                                                                <CurrencyInput placeholder="Enter Amount" />
                                                            </Form.Item>
                                                        </Col>
                                                    </Row>
                                                }
                                            >

                                                {UnlistedStocks.map((item, idx) => (
                                                    <div key={idx} className="balancesheetpdm">
                                                        <Row justify="end">
                                                            {idx > 0 && (
                                                                <Button
                                                                    type="text"
                                                                    icon={<DeleteOutlined style={{ fontSize: 18 }} />}
                                                                    onClick={() => deleteUnlistedStocks(idx)}
                                                                />
                                                            )}
                                                        </Row>
                                                        <Form.Item label="Description Of Securities" className="w50">
                                                            <Input
                                                                placeholder="Enter Description of Securities"
                                                                value={item.DescriptionOfSecurities}
                                                                onChange={(e) => handleChangeUnlistedStocks(idx, "DescriptionOfSecurities", e.target.value)}
                                                            />
                                                            {/* {unlistedStockErrors[idx]?.DescriptionOfSecuritiesErr && (
                                                        <div className="ant-form-item-explain-error">Description is required</div>
                                                    )} */}
                                                        </Form.Item>
                                                        <Form.Item label="In Name Of, No. of Shares Owned" className="w50">
                                                            {/* <Input
                                                        value={item.InNameOf}
                                                        onChange={(e) => handleChangeUnlistedStocks(idx, "InNameOf", e.target.value)}
                                                    /> */}
                                                            <CurrencyInput
                                                                placeholder="Enter No. of Shares Owned"
                                                                value={item.InNameOf}
                                                                onChange={(val) => handleChangeUnlistedStocks(idx, "InNameOf", val)}
                                                            />
                                                            {/* {unlistedStockErrors[idx]?.InNameOfErr && (
                                                        <div className="ant-form-item-explain-error">No. of Shares is required</div>
                                                    )} */}
                                                        </Form.Item>
                                                        {/* <Form.Item label="Number of Shares Owned" className="w50">
                                                    <Input
                                                        value={item.NumberOfSharesOwned}
                                                        onChange={(e) => handleChangeUnlistedStocks(idx, "NumberOfSharesOwned", e.target.value)}
                                                    />
                                                    <CurrencyInput
                                                        value={item.NumberOfSharesOwned}
                                                        onChange={(val) => handleChangeUnlistedStocks(idx, "NumberOfSharesOwned", val)}
                                                    />
                                                    {unlistedStockErrors[idx]?.NumberOfSharesOwnedErr && (
                                                        <div className="ant-form-item-explain-error">Number of Shares Owned is required</div>
                                                    )}
                                                </Form.Item> */}
                                                        <Form.Item label="% Ownership" className="w50">
                                                            <CurrencyInput
                                                                placeholder="Enter % Ownership"
                                                                value={item.Ownership}
                                                                onChange={(val) => handleChangeUnlistedStocks(idx, "Ownership", val)}
                                                            />
                                                            {/* {unlistedStockErrors[idx]?.OwnershipErr && (
                                                        <div className="ant-form-item-explain-error">Ownership is required</div>
                                                    )} */}
                                                        </Form.Item>
                                                        <Form.Item label="Book Value (as of date)" className="w50">
                                                            {/* <Input
                                                        value={item.BookValue}
                                                        onChange={(e) => handleChangeUnlistedStocks(idx, "BookValue", e.target.value)}
                                                    /> */}
                                                            <CurrencyInput
                                                                placeholder="Enter Book Value (as of date)"
                                                                value={item.BookValue}
                                                                onChange={(val) => handleChangeUnlistedStocks(idx, "BookValue", val)}
                                                            />
                                                            {/* {unlistedStockErrors[idx]?.BookValueErr && (
                                                        <div className="ant-form-item-explain-error">BookValue is required</div>
                                                    )} */}
                                                        </Form.Item>
                                                        <Form.Item label="Book Value Amount" className="w50">
                                                            {/* <Input
                                                        value={item.BookValueAmount}
                                                        onChange={(e) => handleChangeUnlistedStocks(idx, "BookValueAmount", e.target.value)}
                                                    /> */}
                                                            <CurrencyInput
                                                                placeholder="Enter Book Value Amount"
                                                                value={item.BookValueAmount}
                                                                onChange={(val) => handleChangeUnlistedStocks(idx, "BookValueAmount", val)}
                                                            />
                                                            {/* {unlistedStockErrors[idx]?.BookValueAmountErr && (
                                                        <div className="ant-form-item-explain-error">BookValue is required</div>
                                                    )} */}
                                                        </Form.Item>
                                                        <Form.Item label="If Pledged, To Whom?" className="w50">
                                                            <Input
                                                                placeholder="Enter To Whom?"
                                                                value={item.IfPledgedTowhom}
                                                                onChange={(e) => handleChangeUnlistedStocks(idx, "IfPledgedTowhom", e.target.value)}
                                                            />
                                                            {/* {unlistedStockErrors[idx]?.IfPledgedTowhomErr && (
                                                        <div className="ant-form-item-explain-error">To Whom is required</div>
                                                    )} */}
                                                        </Form.Item>
                                                    </div>
                                                ))}
                                                <Form.Item style={{ textAlign: "right" }}>
                                                    <Button
                                                        type="link"
                                                        icon={<PlusCircleOutlined />}
                                                        className="f16"
                                                        onClick={addUnlistedStocks}
                                                        disabled={![1,2,4,9].includes(balancesheettotalassetInfo && balancesheettotalassetInfo.Application_Status_Id) ? true : false}
                                                    >
                                                        Add More
                                                    </Button>
                                                    <Button
                                                        type="primary"
                                                        onClick={handleSaveUnlistedStocks}
                                                        disabled={![1,2,4,9].includes(balancesheettotalassetInfo && balancesheettotalassetInfo.Application_Status_Id) ? true : false}
                                                    >
                                                        Save
                                                    </Button>
                                                </Form.Item>

                                            </CollapsePanel>
                                        </Collapse>
                                    </Card>

                                    <Row className="card-section mb15">
                                        <Col className="left-balance">
                                            <label className="f16Bold">Equity Interest in Business </label>
                                        </Col>
                                        <Col className="right-balance">
                                            <Form.Item
                                                name="equityInterestInBusinessCount"
                                            // rules={[
                                            //     {
                                            //         required: true,
                                            //         message: "Equity Interest in Business is required"
                                            //     }]}
                                            >
                                                <CurrencyInput placeholder="Enter Amount" />
                                            </Form.Item>
                                        </Col>
                                    </Row>


                                    <Card className="mb15 BalSheetcardView">
                                        <Collapse accordion
                                            expandIconPosition="end"
                                            ghost
                                            expandIcon={({ isActive }) => (
                                                <span style={{ color: '#1890ff', fontWeight: 'bold' }}>
                                                    {isActive ? 'Hide Details' : 'Add Details'}
                                                </span>
                                            )}>
                                            <CollapsePanel
                                                key="1"
                                                collapsible="icon"
                                                header={
                                                    <Row justify="space-between" align="middle" style={{ width: "100%" }}>
                                                        <Col className="left-balance">
                                                            <label className="f16Bold">RE Investments </label>
                                                        </Col>
                                                        <Col className="right-balance">
                                                            <Form.Item name="investmentTotal"
                                                                // rules={[
                                                                //     {
                                                                //         required: true,
                                                                //         message: "Please Enter RE Investments"

                                                                //     }
                                                                // ]}
                                                                style={{ marginBottom: 0 }}
                                                            >
                                                                <CurrencyInput placeholder="Enter Amount" />
                                                            </Form.Item>
                                                        </Col>
                                                    </Row>
                                                }
                                            >

                                                {ReInvestmentsAssets.map((reInvestmentsAsset, idx) => (
                                                    <div key={idx} className="balancesheetpdm">
                                                        <Row justify="end">
                                                            {idx > 0 && (
                                                                <Button
                                                                    type="text"
                                                                    icon={<DeleteOutlined style={{ fontSize: 18 }} />}
                                                                    onClick={() => deleteReInvestmentsAssets(idx)}
                                                                />
                                                            )}
                                                        </Row>

                                                        <Form.Item label="Property & Location" className="w50">
                                                            <Input
                                                                placeholder="Enter Property & Location"
                                                                value={reInvestmentsAsset.PropertyLocation}
                                                                onChange={(e) => handleChangeReInvestment(idx, "PropertyLocation", e.target.value)}
                                                            />
                                                            {/* {reInvestmentErrors?.[idx]?.PropertyLocationErr && (
                                                        <div className="ant-form-item-explain-error">Property & Location is required</div>
                                                    )} */}
                                                        </Form.Item>

                                                        <Form.Item label="Owner" className="w50">
                                                            <Input
                                                                placeholder="Enter Owner"
                                                                value={reInvestmentsAsset.Owner || ""}
                                                                onChange={(e) => handleChangeReInvestment(idx, "Owner", e.target.value)}
                                                            />
                                                            {/* {reInvestmentErrors?.[idx]?.OwnerErr && (
                                                        <div className="ant-form-item-explain-error">Owner is required</div>
                                                    )} */}
                                                        </Form.Item>

                                                        {reInvestmentsAsset.Owner === "Guarantor" && (
                                                            <>
                                                                <Form.Item label="1. Is Beneficial Interest Assigned?" className="w50">
                                                                    <Radio.Group
                                                                        value={reInvestmentsAsset.isBeneficialInterestAssigned}
                                                                        onChange={(e) => handleChangeReInvestment(idx, "isBeneficialInterestAssigned", e.target.value)}
                                                                    >
                                                                        <Radio value="Yes">Yes</Radio>
                                                                        <Radio value="No">No</Radio>
                                                                    </Radio.Group>
                                                                    {/* {reInvestmentErrors?.[idx]?.isBeneficialInterestAssignedErr && (
                                                                <div className="ant-form-item-explain-error">This field is required</div>
                                                            )} */}
                                                                </Form.Item>

                                                                {reInvestmentsAsset.isBeneficialInterestAssigned === "Yes" && (
                                                                    <Form.Item label="To Whom?" className="w50">
                                                                        <Input
                                                                            value={reInvestmentsAsset.beneficialInterestDetails}
                                                                            onChange={(e) => handleChangeReInvestment(idx, "beneficialInterestDetails", e.target.value)}
                                                                        />
                                                                        {/* {reInvestmentErrors?.[idx]?.beneficialInterestDetailsErr && (
                                                                    <div className="ant-form-item-explain-error">To Whom is required</div>
                                                                )} */}
                                                                    </Form.Item>
                                                                )}

                                                                <Form.Item label="2. Are you directly or indirectly obligated on the debt?" className="w50">
                                                                    <Radio.Group
                                                                        value={reInvestmentsAsset.isObligatedOnDebt}
                                                                        onChange={(e) => handleChangeReInvestment(idx, "isObligatedOnDebt", e.target.value)}
                                                                    >
                                                                        <Radio value="Yes">Yes</Radio>
                                                                        <Radio value="No">No</Radio>
                                                                    </Radio.Group>
                                                                    {/* {reInvestmentErrors?.[idx]?.isObligatedOnDebtErr && (
                                                                <div className="ant-form-item-explain-error">This field is required</div>
                                                            )} */}
                                                                </Form.Item>

                                                                {reInvestmentsAsset.isObligatedOnDebt === "Yes" && (
                                                                    <Form.Item label="To Whom?" className="w50">
                                                                        <Input
                                                                            value={reInvestmentsAsset.obligatedDebtDetails}
                                                                            onChange={(e) => handleChangeReInvestment(idx, "obligatedDebtDetails", e.target.value)}
                                                                        />
                                                                        {/* {reInvestmentErrors?.[idx]?.obligatedDebtDetailsErr && (
                                                                    <div className="ant-form-item-explain-error">To Whom is required</div>
                                                                )} */}
                                                                    </Form.Item>
                                                                )}
                                                            </>
                                                        )}

                                                        <Form.Item label="Date Acquired" className="w50">
                                                            <DatePicker
                                                                value={reInvestmentsAsset.dateAcquired ? moment(reInvestmentsAsset.dateAcquired, "YYYY-MM-DD") : null}
                                                                onChange={(date) => handleChangeReInvestment(idx, "dateAcquired", date?.format("YYYY-MM-DD"))}
                                                                format="MM/DD/YYYY"
                                                                style={{ width: "100%" }}
                                                                disabledDate={(current) => current && current.isAfter(moment(), "day")}
                                                            />
                                                            {/* {reInvestmentErrors?.[idx]?.dateAcquiredErr && (
                                                        <div className="ant-form-item-explain-error">Date Acquired is required</div>
                                                    )} */}
                                                        </Form.Item>
                                                        <Form.Item label="Market Value" className="w50">
                                                            <CurrencyInput
                                                                placeholder="Enter Market Value"
                                                                value={reInvestmentsAsset.marketValue}
                                                                onChange={(val) => handleChangeReInvestment(idx, "marketValue", val)}
                                                            />
                                                            {/* {reInvestmentErrors?.[idx]?.marketValueErr && (
                                                        <div className="ant-form-item-explain-error">Market Value is required</div>
                                                    )} */}
                                                        </Form.Item>

                                                        <Form.Item label="Cost" className="w50 displayNone">
                                                            <CurrencyInput
                                                                placeholder="Enter Cost"
                                                                value={reInvestmentsAsset.cost}
                                                                onChange={(val) => handleChangeReInvestment(idx, "cost", val)}
                                                            />
                                                            {/* {reInvestmentErrors?.[idx]?.costErr && (
                                                        <div className="ant-form-item-explain-error">Cost is required</div>
                                                    )} */}
                                                        </Form.Item>


                                                        <Divider></Divider>
                                                        <Form.Item label="Mortgagor" className="w50">
                                                            <Input
                                                                placeholder="Enter Mortgagor"
                                                                value={reInvestmentsAsset.mortgagor}
                                                                onChange={(e) => handleChangeReInvestment(idx, "mortgagor", e.target.value)}
                                                            />
                                                            {/* {reInvestmentErrors?.[idx]?.mortgagorErr && (
                                                        <div className="ant-form-item-explain-error">Mortgagor is required</div>
                                                    )} */}
                                                        </Form.Item>

                                                        <Form.Item label="Maturity Date" className="w50">
                                                            <DatePicker
                                                                placeholder="Select Maturity Date"
                                                                value={reInvestmentsAsset.maturity ? moment(reInvestmentsAsset.maturity, "YYYY-MM-DD") : null}
                                                                onChange={(date) => handleChangeReInvestment(idx, "maturity", date?.format("YYYY-MM-DD"))}
                                                                format="MM/DD/YYYY"
                                                                style={{ width: "100%" }}
                                                                disabledDate={(current) => current && current.isBefore(moment(), "day")}
                                                            />
                                                            {/* {reInvestmentErrors?.[idx]?.maturityErr && (
                                                        <div className="ant-form-item-explain-error">Maturity Date is required</div>
                                                    )} */}
                                                        </Form.Item>

                                                        <Form.Item label="Amount" className="w50">
                                                            <CurrencyInput
                                                                placeholder="Enter Amount"
                                                                value={reInvestmentsAsset.amount}
                                                                onChange={(val) => handleChangeReInvestment(idx, "amount", val)}
                                                            />
                                                            {/* {reInvestmentErrors?.[idx]?.amountErr && (
                                                        <div className="ant-form-item-explain-error">Amount is required</div>
                                                    )} */}
                                                        </Form.Item>
                                                    </div>
                                                ))}

                                                <Form.Item style={{ textAlign: "right" }}>
                                                    <Button
                                                        type="link"
                                                        icon={<PlusCircleOutlined />}
                                                        className="f16"
                                                        onClick={addReInvestmentsAssets}
                                                        disabled={![1,2,4,9].includes(balancesheettotalassetInfo && balancesheettotalassetInfo.Application_Status_Id) ? true : false}
                                                    >
                                                        Add More
                                                    </Button>
                                                    <Button
                                                        type="primary"
                                                        onClick={saveReInvestmentData}
                                                        disabled={![1,2,4,9].includes(balancesheettotalassetInfo && balancesheettotalassetInfo.Application_Status_Id) ? true : false}
                                                    >
                                                        Save
                                                    </Button>
                                                </Form.Item>

                                            </CollapsePanel>
                                        </Collapse>
                                    </Card>

                                    <Card className="mb15 BalSheetcardView">
                                        <Collapse accordion
                                            expandIconPosition="end"
                                            ghost
                                            expandIcon={({ isActive }) => (
                                                <span style={{ color: '#1890ff', fontWeight: 'bold' }}>
                                                    {isActive ? 'Hide Details' : 'Add Details'}
                                                </span>
                                            )}>
                                            <CollapsePanel
                                                key="1"
                                                collapsible="icon"
                                                header={
                                                    <Row justify="space-between" align="middle" style={{ width: "100%" }}>
                                                        <Col className="left-balance">
                                                            <label className="f16Bold">General and/or Limited Partnership Interests </label>
                                                        </Col>
                                                        <Col className="right-balance">
                                                            <Form.Item name="generalAndLimitedPartenershipIntrestTotal"
                                                                // rules={[
                                                                //     {
                                                                //         required: true,
                                                                //         message: "General and/or Limited Partnership Interests is required"
                                                                //     }
                                                                // ]}
                                                                style={{ marginBottom: 0 }}
                                                            >
                                                                <CurrencyInput placeholder="Enter Amount" />
                                                            </Form.Item>
                                                        </Col>
                                                    </Row>
                                                }
                                            >
                                                {generalInterest.map((item, idx) => (
                                                    <div key={idx} className="balancesheetpdm">
                                                        <Row justify="end">
                                                            {idx > 0 && (
                                                                <Button
                                                                    type="text"
                                                                    icon={<DeleteOutlined />}
                                                                    onClick={() => deleteGeneralInterest(idx)}
                                                                />
                                                            )}
                                                        </Row>
                                                        <Form.Item label="Name of Partnership" className="w50">
                                                            <Input
                                                                placeholder="Enter Name of Partnership"
                                                                value={item.NameofPartnership}
                                                                onChange={(e) => handleGeneralInterestChange(idx, "NameofPartnership", e.target.value)}
                                                            />
                                                            {/* {generalInterestErrors?.[idx]?.NameofPartnershipErr && (
                                                        <div className="ant-form-item-explain-error">Name of Partnership is required</div>
                                                    )} */}
                                                        </Form.Item>

                                                        <Form.Item label="Type of Investment" className="w50">
                                                            <Select
                                                                allowClear
                                                                placeholder="Select"
                                                                value={item.TypeofInvestment || undefined}
                                                                onChange={(val) => handleGeneralInterestChange(idx, "TypeofInvestment", val)}
                                                            >
                                                                <Select.Option value="Real Estate">Real Estate</Select.Option>
                                                                <Select.Option value="Business">Business</Select.Option>
                                                                <Select.Option value="Trust">Trust</Select.Option>
                                                                <Select.Option value="Other">Other</Select.Option>
                                                            </Select>
                                                            {/* {generalInterestErrors?.[idx]?.TypeofInvestmentErr && (
                                                        <div className="ant-form-item-explain-error">Type of Investment is required</div>
                                                    )} */}
                                                        </Form.Item>

                                                        <Form.Item label="Limited or General Partnership Interest" className="w50">
                                                            <Select
                                                                allowClear
                                                                placeholder="Select"
                                                                value={item.LimitedorGeneral || undefined}
                                                                onChange={(val) => handleGeneralInterestChange(idx, "LimitedorGeneral", val)}
                                                            >
                                                                <Select.Option value="Limited">Limited</Select.Option>
                                                                <Select.Option value="General">General</Select.Option>
                                                            </Select>
                                                            {/* {generalInterestErrors?.[idx]?.LimitedorGeneralErr && (
                                                        <div className="ant-form-item-explain-error">Partnership Interest is required</div>
                                                    )} */}
                                                        </Form.Item>

                                                        <Form.Item label="Amount Invested" className="w50">
                                                            {/* <Input
                                                        value={item.AmountInvested}
                                                        onChange={(e) => handleGeneralInterestChange(idx, "AmountInvested", e.target.value)}
                                                    /> */}
                                                            <CurrencyInput
                                                                placeholder="Enter Amount Invested"
                                                                value={item.AmountInvested}
                                                                onChange={(val) => handleGeneralInterestChange(idx, "AmountInvested", val)}
                                                            />
                                                            {/* {generalInterestErrors?.[idx]?.AmountInvestedErr && (
                                                        <div className="ant-form-item-explain-error">Amount Invested is required</div>
                                                    )} */}
                                                        </Form.Item>

                                                        <Form.Item label="Fair Market Value of Partnership Interest" className="w50">
                                                            {/* <Input
                                                        value={item.FairMarketValueofPartnershipInterest}
                                                        onChange={(e) =>
                                                            handleGeneralInterestChange(idx, "FairMarketValueofPartnershipInterest", e.target.value)
                                                        }
                                                    /> */}
                                                            <CurrencyInput
                                                                placeholder="Enter Fair Market Value of Partnership Interest"
                                                                value={item.FairMarketValueofPartnershipInterest}
                                                                onChange={(val) =>
                                                                    handleGeneralInterestChange(idx, "FairMarketValueofPartnershipInterest", val)
                                                                }
                                                            />
                                                            {/* {generalInterestErrors?.[idx]?.FairMarketValueofPartnershipInterestErr && (
                                                        <div className="ant-form-item-explain-error">Fair Market Value is required</div>
                                                    )} */}
                                                        </Form.Item>

                                                        <Form.Item
                                                            label="Capital Account Statements"
                                                        >
                                                            {item.uploadPath ? (
                                                                <div id="imgDiv" className="imgDiv mb10">
                                                                    <Tooltip title="Download">
                                                                        <a
                                                                            href={item.fullUrl ? item.fullUrl : item.uploadPath}
                                                                            target="_blank"
                                                                            rel="noopener noreferrer"
                                                                            download
                                                                        >
                                                                            <FileOutlined />
                                                                            {item.uploadPath.split('/').pop().split('?')[0] ? "Capital Account Statements" : null}
                                                                        </a>
                                                                    </Tooltip>

                                                                    <Tooltip title="Delete">
                                                                        <Button
                                                                            id="deleteLogoBtn"
                                                                            type="text"
                                                                            icon={<DeleteOutlined />}
                                                                            danger
                                                                            onClick={() => onDeleteCapitalAccountImage(idx)}
                                                                        />
                                                                    </Tooltip>

                                                                </div>
                                                            ) : (
                                                                // Show upload component if no existing image or image has been deleted
                                                                <Upload
                                                                    name="file"
                                                                    listType="picture"
                                                                    maxCount={1}
                                                                    accept=".pdf,.doc,.docx"
                                                                    showUploadList={false}
                                                                    customRequest={({ file, onSuccess }) => {
                                                                        handleFileUploadCapitalAccount(file, item.RowID, idx);
                                                                        onSuccess("ok");
                                                                    }}
                                                                >
                                                                    <Button icon={<UploadOutlined />}>Click to Upload</Button>
                                                                </Upload>
                                                            )}
                                                        </Form.Item>
                                                    </div>
                                                ))}

                                                <Form.Item style={{ textAlign: "right" }}>
                                                    <Button
                                                        type="link"
                                                        icon={<PlusCircleOutlined />}
                                                        className="f16"
                                                        onClick={addGeneralInterest}
                                                        disabled={![1,2,4,9].includes(balancesheettotalassetInfo && balancesheettotalassetInfo.Application_Status_Id) ? true : false}
                                                    >
                                                        Add More
                                                    </Button>
                                                    <Button
                                                        type="primary"
                                                        onClick={saveGeneralInterest}
                                                        disabled={![1,2,4,9].includes(balancesheettotalassetInfo && balancesheettotalassetInfo.Application_Status_Id) ? true : false}
                                                    >
                                                        Save
                                                    </Button>
                                                </Form.Item>
                                            </CollapsePanel>
                                        </Collapse>
                                    </Card>

                                    <Row className="card-section mb15">
                                        <Col className="left-balance">
                                            <label className="f16Bold">Personal Property </label>
                                        </Col>
                                        <Col className="right-balance">
                                            <Form.Item
                                                name="personalPropertyTotal"
                                            // rules={[
                                            //     {
                                            //         required: true,
                                            //         message: "Personal Property is required"
                                            //     }
                                            // ]}
                                            >
                                                <CurrencyInput placeholder="Enter Amount" />
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                    <Row className="card-section mb15">
                                        <Col className="left-balance">
                                            <label className="f16Bold">Other Assets </label>
                                        </Col>
                                        <Col className="right-balance">
                                            <Form.Item
                                                name="otherAssetsTotal"
                                            // rules={[
                                            //     {
                                            //         required: true,
                                            //         message: "Other Assets is required"
                                            //     }
                                            // ]}
                                            >
                                                <CurrencyInput placeholder="Enter Amount" />
                                            </Form.Item>
                                        </Col>
                                    </Row>

                                    <Row className="card-section">
                                        <Col className="left-balance">
                                            <label className="f16Bold"> TOTAL ASSETS</label>
                                        </Col>
                                        <Col className="right-balance">
                                            <Form.Item
                                                name="LiquidMarketableAssetsTotal"
                                                hidden
                                            >
                                                <Input />
                                            </Form.Item>
                                            <Form.Item
                                                name="totalLiquidMarketableAssets"
                                                // rules={[
                                                //     {
                                                //         required: false,
                                                //         message: 'Please enter a value',
                                                //     },
                                                //     {
                                                //         validator: (_, value) =>
                                                //             value > 0
                                                //                 ? Promise.resolve()
                                                //                 : Promise.reject(new Error('Value should not be 0.')),
                                                //     },
                                                // ]}
                                                rules={[{ required: false, message: "Total Assets is required" }]}
                                            >
                                                <CurrencyInput disabled />
                                            </Form.Item>
                                        </Col>
                                    </Row>



                                    {/* <Form.Item style={{ marginTop: "20px" }}>
                                        <div style={{ display: "flex", justifyContent: "flex-end", gap: 16 }}>
                                            <ButtonComponent
                                                type="default"
                                                onClick={onBack}
                                                text="Go Back"
                                            />
                                            <ButtonComponent
                                                type="primary"
                                                text="Save And Proceed"
                                                htmlType="submit"
                                                disabled={![1,2,4,9].includes(balancesheettotalassetInfo && balancesheettotalassetInfo.Application_Status_Id) ? true : false}
                                            />


                                        </div>
                                    </Form.Item> */}

                                    <Form.Item className="mt10">
                                        <Row justify="end" gutter={16}>
                                            <Col>
                                                <ButtonComponent
                                                    type="default"
                                                    onClick={onBack}
                                                    icon={<LeftOutlined />}

                                                    text="Go Back"
                                                />
                                            </Col>
                                            <Col>
                                                <ButtonComponent
                                                    type="primary"
                                                    htmlType="submit"
                                                    disabled={[1,2,4,9].includes(balancesheettotalassetInfo && balancesheettotalassetInfo.Application_Status_Id) ? false : true}
                                                    text={
                                                        <span>
                                                            Save And Proceed <ArrowRightOutlined />
                                                        </span>
                                                    }
                                                    // text="Save And Proceed"
                                                    icon={<RightOutlined />}

                                                />
                                            </Col>
                                        </Row>
                                    </Form.Item>
                                </Form>
                            </Col>
                        </Row>
                    </div>
                </div>
            </LeftLayout>
        </Spin>
    );
};

export default BalanceSheetTotalAssets;